import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  isSidebarOpen: boolean;
  colorMode: 'light' | 'dark';
  userId: string | null;
  sessionId: string | null;
}

const initialState: UIState = {
  isSidebarOpen: true,
  colorMode: 'light',
  userId: null,
  sessionId: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload;
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setColorMode: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.colorMode = action.payload;
    },
    toggleColorMode: (state) => {
      state.colorMode = state.colorMode === 'light' ? 'dark' : 'light';
    },
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload;
    },
  },
});

export const {
  setSidebarOpen,
  toggleSidebar,
  setColorMode,
  toggleColorMode,
  setUserId,
  setSessionId,
} = uiSlice.actions;

export default uiSlice.reducer;
